import { render, staticRenderFns } from "./trendDetail.vue?vue&type=template&id=76399e8e&scoped=true"
import script from "./trendDetail.vue?vue&type=script&lang=js"
export * from "./trendDetail.vue?vue&type=script&lang=js"
import style0 from "./trendDetail.vue?vue&type=style&index=0&id=76399e8e&prod&lang=scss&scoped=true"
import style1 from "./trendDetail.vue?vue&type=style&index=1&id=76399e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76399e8e",
  null
  
)

export default component.exports